import { PackageIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Box2 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <PackageIcon {...rest} size={Sizes[size]} color={fill} />;
};

Box2.displayName = 'Box2';
